const mapEl = document.querySelector('.js-map'),
    mapOptions = {
        zoom: 15,
        panControl: false,
        streetViewControl: false,
        scaleControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: true,
        styles: [
            {
                featureType: 'poi',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'labels.text',
                stylers: [
                    {
                        lightness: 50,
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'labels.text',
                stylers: [
                    {
                        lightness: 50,
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'labels.text',
                stylers: [
                    {
                        lightness: 50,
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'labels.icon',
                stylers: [
                    {
                        lightness: 50,
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'labels.text',
                stylers: [
                    {
                        lightness: 30,
                    },
                ],
            },
        ],
    };
    
    let occasions = document.querySelectorAll('.js-map-address'),
        Map = null,
        Marker = null,
        InfoWindow = null,
        Geocoder = null,
        mapCanvas = null,
        mapMarkers = [],
        markerCounter = 0,
        mapInitialZoom = true,
        informationWindow = null,
        latlngbounds;

function mapZoomEvents() {
    // This is needed to set the zoom after fitbounds,
    google.maps.event.addListener(mapCanvas, 'zoom_changed', function() {
        var zoomChangeBoundsListener = google.maps.event.addListener(
            mapCanvas,
            'bounds_changed',
            function() {
                if (mapCanvas.getZoom() > 15 && mapInitialZoom === true) {
                    // Change max/min zoom here
                    mapCanvas.setZoom(15);
                    mapInitialZoom = false;
                }

                google.maps.event.removeListener(zoomChangeBoundsListener);
            }
        );
    });
}

function generateMapMarkers() {
    occasions.forEach(el => {
        const locationString = el.dataset.address,
            latitudeString = el.dataset.latitude,
            longitudeString = el.dataset.longitude,
            title = el.dataset.title,
            infoWindowContent = `<div class='event__map-infowindow'><h3>${title}</h3><p>${locationString}</p></div>`,
            geocoder = new Geocoder();

        let occasionLatLng = false;

        // Do we have any address data to work with?
        if (
            latitudeString === undefined &&
            longitudeString === undefined &&
            locationString === undefined
        ) {
            // We can't do anything so just continue to the next loop iteration
            return true;
        } else {
            // If we have the latitude and longitude points, lets use those
            if (
                latitudeString !== undefined &&
                latitudeString !== '' &&
                longitudeString !== undefined && longitudeString !== ''
            ) {
                occasionLatLng = new google.maps.LatLng(latitudeString, longitudeString);

                buildMarker(occasionLatLng, title, infoWindowContent);
            } else {
                // Geocode given address
                geocoder.geocode({ address: locationString }, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        occasionLatLng = results[0].geometry.location;

                        buildMarker(occasionLatLng, title, infoWindowContent);
                    }
                });
            }
        }
    });
}

function buildMarker(latLng, title, infoWindowContent) {
    // Create actuall marker on the map
    var mapMarker = new Marker({
        position: latLng,
        map: mapCanvas,
        title: title,
        icon: {
            path:
                'M1.49,12.23A11.42,11.42,0,0,1,.3,9.83,7.64,7.64,0,0,1,0,7.6,7.58,7.58,0,0,1,1,3.8,7.6,7.6,0,0,1,3.66,1,6.84,6.84,0,0,1,7.32,0,6.82,6.82,0,0,1,11,1a7.79,7.79,0,0,1,2.64,2.8,7.58,7.58,0,0,1,1,3.8,7.64,7.64,0,0,1-.3,2.23,11.38,11.38,0,0,1-1.18,2.4q-.62,1-2.52,3.84L7.32,20.72C5.8,18.64,4.7,17.09,4,16.07Q2.09,13.22,1.49,12.23ZM9.76,9.88a3,3,0,0,0,.9-2.21A3.09,3.09,0,0,0,7.59,4.56h0A3.11,3.11,0,0,0,4.5,7.67a3,3,0,0,0,.91,2.21,3,3,0,0,0,4.31,0l0,0',
            fillColor: '#0a3b54',
            fillOpacity: 1,
            strokeOpacity: 0,
            scale: 1.25,
            anchor: new google.maps.Point(10, 28),
        },
    });

    // Add occassionLatLng to array of marker positions
    // so we can re-use them on any resize events
    mapMarkers.push(mapMarker);

    // Add event listener fon marker click to open info window
    google.maps.event.addListener(mapMarker, 'click', function() {
        // Close any open info windows
        if (informationWindow) {
            informationWindow.close();
        }

        // Set the infoWindow to use new content, then open it
        informationWindow = new InfoWindow({
            content: infoWindowContent,
        });

        informationWindow.open(mapCanvas, mapMarker);
    });

    // Extend the bounds of the map viewport to include this marker
    latlngbounds.extend(latLng);

    // Update marker counter by 1
    markerCounter++;

    // If we've added all the markers to our map let's set the final position and zoom level
    if (markerCounter === occasions.length) {
        setMapPositionAndZoom();
    }
}

function setMapPositionAndZoom() {
    // Set the map centre point
    mapCanvas.setCenter(latlngbounds.getCenter());
    mapCanvas.fitBounds(latlngbounds);
}

export async function init() {
    ({ Map, InfoWindow } = await google.maps.importLibrary('maps'));
    ({ Marker } = await google.maps.importLibrary("marker"));
    ({ Geocoder } = await google.maps.importLibrary("geocoding"));

    buildEventMap(mapEl);
}

export function buildEventMap(mapEl) {
    latlngbounds = new google.maps.LatLngBounds();
    occasions = document.querySelectorAll('.js-map-address');
    
    // Create map canvas
    // Setup correct map controls
    mapCanvas = new Map(mapEl, mapOptions);

    // Attach listeners for zoom/bound change envets on the map
    // to limit how far in we get zoomed
    mapZoomEvents();

    // Loop over all event occassions, use lat/long or geocode address,
    // and save to markers array
    generateMapMarkers();
}

export function resizeMap() {
    var centreLatLng = latlngbounds.getCenter();

    google.maps.event.trigger(mapCanvas, 'resize');

    // Setup correct map controls
    mapCanvas.setOptions(mapOptions);

    // Set initial zoom flag to true as we've altered things...
    mapInitialZoom = true;

    mapCanvas.setCenter(centreLatLng);
    mapCanvas.fitBounds(latlngbounds);
}
